 import React from "react";
import PropTypes from "prop-types";
// import classNames from "classnames";
import { breakpoints } from "../../utils";

const Placeholder = () => (
  <div className="configurator-result-placeholder">
    <p>Please select all options to generate specific datasheet</p>
  </div>
);

const addToStorage = (product) => {
  const enquiryProduct = {
    title: product.title,
    description: product.ostendoItemDescription,
    image: product.ostendoProductImages.length ? product.ostendoProductImages[0].crop210x210 : "",
    id: product.objectID,
    code: product.ostendoItemCode,
    pdf: true,
    count: "1",
  };

  const local = localStorage.getItem("enquiry-product");
  const storage = local ? JSON.parse(local) : [];

  const isAlreadyAdded = storage.some((item) => item.id === enquiryProduct.id);

  if (isAlreadyAdded) {
    document.querySelector(".configurator-result__message")?.classList.add("is-active-message");
    return;
  }

  storage.push(enquiryProduct);
  localStorage.setItem("enquiry-product", JSON.stringify(storage));
  window.dispatchEvent(new Event("on-storage"));

  window.dataLayer?.push({
    event: "add-product",
    productName: enquiryProduct.title,
    productCode: enquiryProduct.code,
  });
};

const ResultContent = ({ hit, showBackButton, setStep }) => {
  if (!hit) return null;
 console.log( hit )
  return (
    <div className="configurator-result">
      <div className="configurator-result__image">
        {showBackButton && (
          <button className="configurator-result__back" onClick={() => setStep(0)}>
            <svg><use xlinkHref="#chevron-left" /></svg>
          </button>
        )}
        {hit.ostendoProductImages.length ? (
          <img
            src={hit.ostendoProductImages[0].crop210x210}
            width="210"
            height="210"
            alt={hit.title}
          />
        ) : (
          <div className="configurator-result__placeholder" />
        )}
      </div>
      <div className="configurator-result__body">
        <h5 className="configurator-result__sub-heading">Product code</h5>
        <h4 className="configurator-result__heading">{hit.ostendoItemCode}</h4>
        {!showBackButton && <div className="configurator-result__desc">{hit.ostendoItemDescription}</div>}
        <button
          className="btn"
          onClick={() => addToStorage(hit)}
        >
          Enquire Now
        </button>
        <div className="configurator-result__message">
          This variation is already in your enquiry
        </div>
        <a
          href={`${window.location.origin}/products/pdf/${hit.objectID}`}
          className="configurator__download gtm-product-download"
          target="_blank"
          data-product-name={hit.title}
          data-product-code={hit.ostendoItemCode}
        >
          <svg><use xlinkHref="#datasheet-icon" /></svg>
          Download Specific Datasheet
        </a>
        {window.showPhotometricButton && hit.photometricFile && (
          <a
            href={hit.photometricFile}
            className="configurator__download"
            target="_blank"
          >
            <svg><use xlinkHref="#datasheet-icon" /></svg>
            Download Photometric File
          </a>
        )}
      </div>
    </div>
  );
};

const Result = ({ hit, items = [], attributes = [], setStep = () => {} }) => {
    
  if (!hit) return null;

  const isComplete = attributes.every(attribute =>
    items.some(item => item.attribute === attribute.value)
  );
  if (!isComplete) {
    return <Placeholder />;
  }

  const isDesktop = window.matchMedia(breakpoints.desk).matches;
  return (
    <ResultContent
      hit={hit}
      showBackButton={!isDesktop}
      setStep={setStep}
    />
  );
};

Result.propTypes = {
  hit: PropTypes.shape({
    image: PropTypes.arrayOf(PropTypes.string),
    ostendoItemCode: PropTypes.string,
    ostendoItemDescription: PropTypes.string,
    title: PropTypes.string,
    objectID: PropTypes.string,
    ostendoProductImages: PropTypes.arrayOf(
      PropTypes.shape({
        crop210x210: PropTypes.string,
      })
    ),
    photometricFile: PropTypes.string,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      attributeName: PropTypes.string,
    })
  ),
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    })
  ),
  setStep: PropTypes.func,
};

export default Result;